import Header from "@/components/listen/Header";
import Hero from "@/components/listen/Hero";
import MissionMarquee from "@/components/listen/MissionMarquee";
import RegularSections from "@/components/listen/RegularSections";
import SignatureFeatures from "@/components/listen/SignatureFeatures";
import QuarterlyThemes from "@/components/listen/QuarterlyThemes";
import Advertisers from "@/components/listen/Advertisers";
import Newsletter from "@/components/listen/Newsletter";
import Footer from "@/components/listen/Footer";

export default function ListenLanding() {
  return (
    <div data-testid="listen-landing" className="min-h-screen bg-[#F4F4F0] text-[#1A1A1A]">
      <Header />
      <main>
        <Hero />
        <MissionMarquee />
        <RegularSections />
        <SignatureFeatures />
        <QuarterlyThemes />
        <Advertisers />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}
